module.exports = __webpack_public_path__ + "static/media/bj.beefc92d.webp";